module.exports = __webpack_public_path__ + "a7de8e3a.svg";